module.exports = __webpack_public_path__ + "src/assets/img/topre.2f50991b.png";